"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importCounterGroupsReducer = exports.updateCounterGroupsReducer = exports.createCounterGroupsReducer = exports.fetchAllCounterGroupsReducer = exports.fetchCounterGroupsReducer = exports.clearAllCounterGroupsState = exports.clearCounterGroupsState = exports.importCounterGroupsSlice = exports.updateCounterGroupsSlice = exports.createCounterGroupsSlice = exports.fetchAllCounterGroupsSlice = exports.fetchCounterGroupsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const counterGroupsAction_1 = require("./counterGroupsAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
const importInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.fetchCounterGroupsSlice = (0, toolkit_1.createSlice)({
    name: 'counterGroups/fetch',
    initialState: fetchInitialState,
    reducers: {
        clearCounterGroupsState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(counterGroupsAction_1.fetch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(counterGroupsAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(counterGroupsAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchAllCounterGroupsSlice = (0, toolkit_1.createSlice)({
    name: 'counterGroups/fetchAll',
    initialState: fetchInitialState,
    reducers: {
        clearAllCounterGroupsState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(counterGroupsAction_1.fetchAll.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(counterGroupsAction_1.fetchAll.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(counterGroupsAction_1.fetchAll.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createCounterGroupsSlice = (0, toolkit_1.createSlice)({
    name: 'counterGroups/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(counterGroupsAction_1.create.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(counterGroupsAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(counterGroupsAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateCounterGroupsSlice = (0, toolkit_1.createSlice)({
    name: 'counterGroups/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(counterGroupsAction_1.update.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(counterGroupsAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(counterGroupsAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.importCounterGroupsSlice = (0, toolkit_1.createSlice)({
    name: 'counterGroups/import',
    initialState: importInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(counterGroupsAction_1.importCounterGroups.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(counterGroupsAction_1.importCounterGroups.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(counterGroupsAction_1.importCounterGroups.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.clearCounterGroupsState = exports.fetchCounterGroupsSlice.actions.clearCounterGroupsState;
exports.clearAllCounterGroupsState = exports.fetchAllCounterGroupsSlice.actions.clearAllCounterGroupsState;
exports.fetchCounterGroupsReducer = exports.fetchCounterGroupsSlice.reducer;
exports.fetchAllCounterGroupsReducer = exports.fetchAllCounterGroupsSlice.reducer;
exports.createCounterGroupsReducer = exports.createCounterGroupsSlice.reducer;
exports.updateCounterGroupsReducer = exports.updateCounterGroupsSlice.reducer;
exports.importCounterGroupsReducer = exports.importCounterGroupsSlice.reducer;
